module.exports = __webpack_public_path__ + "static/media/vi_hk.3537486d.png";